const FILTERS = "@FILTERS";
const filters = JSON.parse(localStorage.getItem(FILTERS));

const initialState = filters
  ? {
      filters: filters
    }
  : {
      filters: {}
    };

export const filter = {
  namespaced: true,
  state: initialState,
  actions: {
    save({ commit }, listFilters) {
      commit("save", listFilters);
    },
    clear({ commit }) {
      commit("clear");
    }
  },
  mutations: {
    save(state, listFilters) {
      listFilters.forEach(function(element) {
        state.filters[element.type] = element.value;
      });
      localStorage.setItem(FILTERS, JSON.stringify(state.filters));
    },
    clear(state) {
      state.filters = {};
      localStorage.removeItem(FILTERS);
    }
  }
};
